<div class="row no-gutters mt-5">
	<div class="col-lg-6">
		<ngb-pagination [collectionSize]="collectionSize" [page]="page" [pageSize]="pageSize"
			(pageChange)="changePageNumber($event)" [boundaryLinks]="true" [directionLinks]="true" [maxSize]="1"
			[ellipses]="false">
			<ng-template ngbPaginationFirst>&laquo;</ng-template>
			<ng-template ngbPaginationPrevious><i class="material-icons md-18">chevron_left</i></ng-template>
			<ng-template ngbPaginationNumber>{{ page }}</ng-template>
			<ng-template ngbPaginationNext><i class="material-icons md-18">chevron_right</i></ng-template>
			<ng-template ngbPaginationLast>&raquo;</ng-template>
		</ngb-pagination>
		<select data-testid="SUBSYS2_ARCHIVE_PAGINATION_SELECT" class="form-control select-items ms-5"
			[(ngModel)]="pageSize" (change)="changePageSize()">
			@for (size of pageSizeList; track size) {
			<option [value]="size">{{ size }}</option>
			}
		</select>
	</div>
	<div class="col-lg-6 text-end">
		<span data-testid="SUBSYS2_ARCHIVE_PAGINATION_TXT" class="results-items">
			{{collectionSize}} {{labels().ARCHIVE_PAGINATION_COMPONENT_ITEMS}} {{totalPages}}
			{{labels().ARCHIVE_PAGINATION_COMPONENT_PAGES}}
		</span>
	</div>
</div>